import { AppState } from '..';
import { FETCH_USERS_SUCCESS, SET_USERS_FIELD, RESET_USERS } from '../actions/usersActions'
import { IUserPagination } from '../models/Users';
import { BillsbyAdminAction } from '../models/BillsbyAdminAction';
import { GetTrialLimitsResponse, TrialLimit } from '../utils/grpc/generated/Billsby.Protos/core/private/triallimits/triallimits_pb';
import { FETCH_FREE_TRIALS_SUCCESS, RESET_FREE_TRIALS, SET_FREE_TRIAL_LIMIT_FIELDS } from '../actions/freeTrialsActions';
import { divideNumberBy100 } from '../utils/commonUtils';

export interface IFreeTrialReducerState {
  standardTrialLimit?: number,
  newStandardTrialLimit?: number,
  alternateFreeTrials: TrialLimit[]
}

const initState = {
  standardTrialLimit: undefined,
  newStandardTrialLimit: undefined,
  alternateFreeTrials: []
};

export default function freeTrialsReducer(
  state: IFreeTrialReducerState = initState,
  action: BillsbyAdminAction,
  store: AppState
) {
  switch (action.type) {
    case FETCH_FREE_TRIALS_SUCCESS:
      const trialLimitData = action.response as GetTrialLimitsResponse;
      let standardTrialLimitValue: number | undefined = 0;
      if(!!trialLimitData.getStandard()) {
        standardTrialLimitValue = divideNumberBy100((trialLimitData.getStandard() as TrialLimit).getLimit());
      }
      return { ...state, standardTrialLimit: standardTrialLimitValue,
        newStandardTrialLimit: standardTrialLimitValue,
        alternateFreeTrials: trialLimitData.getAlternatesList() };      
    case SET_FREE_TRIAL_LIMIT_FIELDS:
      return { ...state, [action.fieldName]: action.fieldValue }
    case RESET_FREE_TRIALS:
      return { ...initState };
    default:
      return state;
  }
}
